import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import client, { formatApiError, TOKEN_KEY } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await client.post("/auth/login", { email, password });
      localStorage.setItem(TOKEN_KEY, data.access_token);
      navigate("/admin/aanvragen");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Inloggen mislukt.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
            <Lock size={24} className="text-primary" />
          </div>
          <h1 className="font-heading text-3xl font-semibold">Beheer</h1>
          <p className="text-muted-foreground mt-2">Log in om aanvragen te bekijken.</p>
        </div>
        <form data-testid="admin-login-form" onSubmit={submit} className="bg-card border border-border rounded-2xl p-7 space-y-5">
          {error && <div data-testid="admin-login-error" className="bg-destructive/10 text-destructive text-sm rounded-lg px-4 py-3">{error}</div>}
          <div>
            <label className="block text-sm font-medium mb-1.5">E-mailadres</label>
            <input data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-background border border-border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1.5">Wachtwoord</label>
            <input data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-background border border-border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary" />
          </div>
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="w-full bg-primary text-primary-foreground font-medium rounded-full px-6 py-3 hover:bg-primary-hover transition-colors disabled:opacity-60">
            {loading ? "Bezig..." : "Inloggen"}
          </button>
          <a href="/" className="block text-center text-sm text-muted-foreground hover:text-primary transition-colors">Terug naar de website</a>
        </form>
      </div>
    </div>
  );
}
